import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APIResponse } from "src/app/core/models/api-response";
import { environment } from "src/environments/environment";
import { IExecuteSeccess, IImport, IMatchingColumn, IResponseMatching } from "../models/imports.models";
import { IPageCount } from "src/app/shared/models/page.model";
import { IInventoryFilterRequest } from "../../produits/models/products.models";

@Injectable({
    providedIn: 'root',
  })
  export class ImportProductsService {
  
    constructor(private http: HttpClient) { }

    public listImports(
      page: IPageCount,
      filter: IInventoryFilterRequest | undefined,
      search: string | undefined
    ): Observable<APIResponse<IImport>> {
      const params = new HttpParams().set('page', page.number).set('limit', page.size).set('filters', JSON.stringify(filter)).set('key', search!);
      return this.http.get<APIResponse<IImport>>(
        environment.BASE_URL_API + 'products/imports', { params }
      );
    }
  
    public importProducts(file: any): Observable<APIResponse<IResponseMatching>> {
      return this.http.post<APIResponse<IResponseMatching>>(
        environment.BASE_URL_API + 'products/imports/set-file',
        file
      );
    }

    public reImportProducts(id: number, file: any): Observable<APIResponse<IResponseMatching>> {
      return this.http.post<APIResponse<IResponseMatching>>(
        environment.BASE_URL_API + 'products/imports/' + id + '/reset-file',
        file
      );
    }

    public matchingColumns(id: number, matchingColumns: IMatchingColumn): Observable<APIResponse<IExecuteSeccess>> {
      return this.http.post<APIResponse<IExecuteSeccess>>(
        environment.BASE_URL_API + 'products/imports/' + id + '/execute',
        matchingColumns
      );
    }

    public detailsImport(id: number): Observable<APIResponse<IExecuteSeccess>> {
      return this.http.get<APIResponse<IExecuteSeccess>>(
        environment.BASE_URL_API + 'products/imports/' + id
      );
    }

    public getFileImported(id: number): Observable<{data: [], object: {file: string}}> {
      return this.http.get<{data: [], object: {file: string}}>(
        environment.BASE_URL_API + 'products/imports/' + id + '/download-file'
      );
    }
}